import { isProduction } from './utils/env';

export const PN_MAPS_URL = isProduction()
  ? 'https://maps.stackdx.com'
  : 'https://staging-maps.stackdx.com';

export const PN_LOG_VIEWER_URL = isProduction()
  ? 'https://log-viewer.stackdx.com'
  : 'https://staging-log-viewer.stackdx.com';

export const PN_FORMATIONS_VIEWER_URL = 'https://formations.stackdx.com';

export const STACKDX_URL = isProduction()
  ? 'https://app.stackdx.com'
  : 'https://staging.stackdx.com';

export const STACK_INTEL_URL = isProduction()
  ? 'https://intel.stackdx.com'
  : 'https://staging-intel.stackdx.com';

export const ADMIN_PANEL_URL = isProduction()
  ? 'https://admin.stackdx.com'
  : 'https://staging-admin.stackdx.com';
